import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DateTime } from "luxon";

export default function DateTimeInput({ date, time, onDateChange, onTimeChange, timezone = "America/Santiago" }) {
  // Calcular el GMT offset actual de la zona horaria
  const getGMTOffset = () => {
    try {
      const now = DateTime.now().setZone(timezone);
      return now.toFormat('ZZZZ'); // Formato: GMT-3, GMT-4, etc.
    } catch (error) {
      return '';
    }
  };

  const gmtOffset = getGMTOffset();

  return (
    <div className="w-full space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-300 mb-2">
          <FontAwesomeIcon icon="fa-solid fa-calendar" className="mr-2" />
          Fecha del Evento
          {gmtOffset && <span className="text-xs text-gray-400 ml-2">({gmtOffset})</span>}
        </label>
        <input
          type="date"
          value={date}
          onChange={(e) => onDateChange(e.target.value)}
          className="date-input-icon-white w-full px-4 py-3 bg-aw-bluedark border border-gray-600 rounded-sm text-white focus:outline-none focus:border-aw-green transition duration-300"
        />
      </div>
      
      <div>
        <label className="block text-sm font-medium text-gray-300 mb-2">
          <FontAwesomeIcon icon="fa-solid fa-clock" className="mr-2" />
          Hora del Evento
          {gmtOffset && <span className="text-xs text-gray-400 ml-2">({gmtOffset})</span>}
        </label>
        <input
          type="time"
          value={time}
          onChange={(e) => onTimeChange(e.target.value)}
          className="date-input-icon-white w-full px-4 py-3 bg-aw-bluedark border border-gray-600 rounded-sm text-white focus:outline-none focus:border-aw-green transition duration-300"
        />
      </div>
    </div>
  );
}
